var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgUseraccountStandard = function SvgUseraccountStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.5l-1-1.1.1-1.5-1.5-.3-.8-1.3-1.4.6-1.4-.6-.8 1.3-1.5.3.1 1.5-1 1.1 1 1.1-.1 1.5 1.5.3.8 1.3 1.4-.6 1.4.6.8-1.3 1.5-.3-.1-1.5 1-1.1zm-5.3 1.9l-1.6-1.6.6-.6.9 1 2.4-2.4.6.6-2.9 3z",
    fill: "#fabc3c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 20H12c-1.8 0-3.5-.6-4.9-1.7.4-.9 3-1.8 4.9-1.8h.2c.2-.7.5-1.3.9-1.9-.4 0-.7-.1-1.1-.1-1.5 0-4.9.6-6.4 2.3C3 13.3 3.7 8.3 7.2 5.6s8.5-2 11.2 1.5c1 1.5 1.6 3.2 1.6 4.9v.3c.7.2 1.3.6 1.9 1.1.8-5.5-2.9-10.6-8.5-11.5s-10.6 3-11.5 8.5 3 10.6 8.5 11.5c1 .2 2 .2 3 0-.4-.6-.8-1.2-1.1-1.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6c-1.9 0-3.5 1.6-3.5 3.5S10.1 13 12 13s3.5-1.6 3.5-3.5S13.9 6 12 6zm0 5c-.8 0-1.5-.7-1.5-1.5S11.2 8 12 8s1.5.7 1.5 1.5S12.8 11 12 11z"
  })));
};
export default SvgUseraccountStandard;